import { CONTEST_SCOPABLE_REASONS } from "./contest.types.js";
import { z } from "zod";

//#region src/lib/contest/special-event.ts
/** Every type of special event; each one has its own params schema below. */
let ContestSpecialEventKind = /* @__PURE__ */ function(ContestSpecialEventKind) {
	/** Multiplies the points of the targeted awards while the event runs. */
	ContestSpecialEventKind["Boost"] = "boost";
	return ContestSpecialEventKind;
}({});
const ContestSpecialEventKindSchema = z.enum(ContestSpecialEventKind);
const ContestScopableReasonSchema = z.enum(CONTEST_SCOPABLE_REASONS);
const ContestBoostParamsSchema = z.object({
	kind: z.literal(ContestSpecialEventKind.Boost),
	multiplier: z.number().int().min(2).max(10),
	reasons: z.array(ContestScopableReasonSchema).min(1)
});
/** Kind-specific settings of a special event, discriminated by `kind`. */
const ContestSpecialEventParamsSchema = z.discriminatedUnion("kind", [ContestBoostParamsSchema]);

//#endregion
export { ContestBoostParamsSchema, ContestScopableReasonSchema, ContestSpecialEventKind, ContestSpecialEventKindSchema, ContestSpecialEventParamsSchema };
//# sourceMappingURL=special-event.js.map